import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IntakeCreateComponent } from '../intake/intake-create.component';
import { SurveyPageComponent } from '../survey-page/survey-page.component';
import { SurveyTypesListComponent } from '../admin/survey-types-list/survey-types-list.component';
import { SurveyCreateComponent } from '../admin/survey-create/survey-create.component';
import { SurveyEditComponent } from '../admin/survey-edit/survey-edit.component';
import { SurveyPreviewComponent } from '../admin/survey-preview/survey-preview.component';
import { UserVoiceComponent } from '../admin/user-voice/user-voice.component';
import { AdminAccessDeniedComponent } from '../admin/admin-access-denied/admin-access-denied.component';
import { adminAccessGuard } from '../guards/admin-access.guard';

const routes: Routes = [
  { path: '', redirectTo: 'intake/create', pathMatch: 'full' },
  { path: 'intake/create', component: IntakeCreateComponent },
  { path: 'survey/:surveyRunId', component: SurveyPageComponent },
  { path: 'access-denied', component: AdminAccessDeniedComponent },
  { path: 'admin/survey-types', component: SurveyTypesListComponent, canActivate: [adminAccessGuard] },
  { path: 'admin/survey-types/create', component: SurveyCreateComponent, canActivate: [adminAccessGuard] },
  { path: 'admin/survey-types/:id/edit', component: SurveyEditComponent, canActivate: [adminAccessGuard] },
  { path: 'admin/survey-types/:id/preview', component: SurveyPreviewComponent, canActivate: [adminAccessGuard] },
  { path: 'admin/user-voice', component: UserVoiceComponent, canActivate: [adminAccessGuard] },
  { path: '**', redirectTo: 'intake/create' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
